import { StylesConfig } from 'react-select'

export function getOverviewDropdownStyles(
  isError: boolean,
  isClearable: boolean,
  isMobile: boolean,
): StylesConfig<{ label: string; value: string | number }, true> {
  return {
    control: (provided) => ({
      ...provided,
      border: 0,
      borderWidth: 2,
      borderRadius: 8,
      borderColor: isError ? '#EE533D' : '#E7E6E4',
      backgroundColor: isError ? '#FFE4DA' : 'white',
      textDecoration: 'underline',
      textAlign: 'right',
      fontWeight: 700,
    }),
    placeholder: (provided) => ({
      ...provided,
      color: isError ? '#c62c2c' : '#A7A6A4',
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      paddingRight: '8px',
    }),
    clearIndicator: (provided) => ({
      ...provided,
      display: isClearable ? 'block' : 'none',
      backgroundColor: isError ? '#EE533D' : provided.backgroundColor,
      color: 'black',
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      display: isClearable ? 'none' : 'block',
    }),
    indicatorSeparator: (provided) => ({
      ...provided,
      display: 'none',
    }),
    input: (provided) => ({
      ...provided,
      visibility: 'unset',
    }),
    option: (provided) => ({
      ...provided,
      fontSize: isMobile ? '14px' : '12px',
    }),
    multiValueRemove: (provided) => ({
      ...provided,
      opacity: 0,
    }),
  }
}

export function getDropdownStyles(
  isError: boolean,
  isClearable: boolean,
  isMobile: boolean,
): StylesConfig<{ label: string; value: string | number }, true> {
  return {
    control: (provided) => ({
      ...provided,
      padding: '10px',
      borderWidth: 2,
      borderRadius: 8,
      borderColor: isError ? '#EE533D' : '#E7E6E4',
      backgroundColor: isError ? '#FFE4DA' : 'white',
    }),
    placeholder: (provided) => ({
      ...provided,
      color: isError ? '#c62c2c' : '#A7A6A4',
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      paddingRight: '0px',
    }),
    clearIndicator: (provided) => ({
      ...provided,
      display: isClearable ? 'block' : 'none',
      backgroundColor: isError ? '#EE533D' : provided.backgroundColor,
      color: 'black',
    }),
    indicatorSeparator: (provided) => ({
      ...provided,
      backgroundColor: isError ? '#EE533D' : provided.backgroundColor,
      paddingTop: '8px',
    }),
    input: (provided) => ({
      ...provided,
      visibility: 'unset',
    }),
    option: (provided) => ({
      ...provided,
      fontSize: isMobile ? '14px' : '12px',
    }),
    multiValueRemove: (provided) => ({
      ...provided,
      opacity: 0,
    }),
  }
}
